// extracted by mini-css-extract-plugin
export default {"text":"Comment_text__-apmo","showComment":"Comment_showComment__tEMwk"};